import React, { useState, useEffect, useRef } from 'react';
import ReactAudioPlayer from 'react-audio-player';
import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled';

function AudioPlayer(props) {
    const [play, pressPlay] = useState(false);

    if (play) {
        return(
            <div>
                <i style={{marginLeft: 20}}>{props.audio.title}</i>
                <br/>
                <ReactAudioPlayer 
                style={{marginTop:5}}
                controlsList="nodownload"
                src={props.audio.url}
                autoPlay={true}
                controls={true}
            />
            </div>

        )
    } else {
        return(
            <div style={{marginBottom: 10, display: 'flex',
                alignItems: 'center'}}
                onClick={()=>pressPlay(true)}
                >
            
                <PlayCircleFilledIcon style={{
                    color:"#7d93c8", 
                    height: 30, 
                    width: 30}} />
        
                <i style={{marginLeft: 10}}>{props.audio.title}</i>
    
            </div>
        )
        }
    }

export default AudioPlayer